import React, { useEffect } from 'react';
import styles from './BrandAnalytics.module.css';
import {
    OptimizedMotionH1,
    OptimizedMotionP,
    OptimizedMotion,
} from '../../../shared/ui/optimized-motion/OptimizedMotion';
import ReadMoreButton from './ReadMoreButton';
import { useNavigate } from 'react-router-dom';

const BrandAnalytics: React.FC = () => {
    const navigate = useNavigate();
    useEffect(() => {
        document.documentElement.scrollTop = 0;
        document.body.scrollTop = 0;
    }, []);
    return (
        <div className={styles.container}>
            <main className={styles.main}>
                {/* Hero Section */}
                <section className={styles.hero}>
                    <OptimizedMotionH1 className={styles.title} type="slide-down" delay={0.2}>
                        <span className={styles.titleHighlight}>Brand </span>{' '}
                        <span className={styles.wrenchIcon}>📊</span> analytics
                    </OptimizedMotionH1>
                </section>

                {/* Features Section */}
                <section className={styles.features}>
                    {/* Feature 1: Listen to Your Voice */}
                    <OptimizedMotion className={styles.featureCard} type="slide-up" delay={0.2}>
                        <div className={styles.featureIcon}>🎧</div>

                        <h3 className={styles.featureTitle}>Listen to Your Voice</h3>
                        <p className={styles.featureDescription}>
                            Track tone, consistency, and engagement in real time. Benchmark content
                            against your style guide to see where your brand shines or drifts.
                        </p>
                    </OptimizedMotion>

                    {/* Feature 2: Turn Insight into Action */}
                    <OptimizedMotion className={styles.featureCard} type="slide-up" delay={0.4}>
                        <div className={styles.featureIcon}>⚡</div>

                        <h3 className={styles.featureTitle}>Turn Insight into Action</h3>
                        <p className={styles.featureDescription}>
                            Dashboards map tone, sentiment, and key phrases to results like clicks
                            and conversions. Filter by channel or audience and catch anomalies
                            early.{' '}
                        </p>
                    </OptimizedMotion>

                    {/* Feature 3: Close the Feedback Loop */}
                    <OptimizedMotion className={styles.featureCard} type="slide-up" delay={0.3}>
                        <div className={styles.featureIcon}>🤝</div>

                        <h3 className={styles.featureTitle}>Close the Feedback Loop</h3>
                        <p className={styles.featureDescription}>
                            Insights flow back into creation tools: AI suggests edits, designers
                            test colors, and managers run A/B tests — all in one workspace.
                        </p>
                    </OptimizedMotion>
                </section>
            </main>
        </div>
    );
};

export default BrandAnalytics;
